import React, { useEffect, useState } from "react";

import "./IndustrialProduct.css";

const IndustrialProduct = ({ title, img, details = [], id, onSelect }) => {
  const [isImageExpanded, setIsImageExpanded] = useState(false);

  const abrirImagen = (e) => {
    if (e) {
      e.stopPropagation();
    }

    setIsImageExpanded(true);
  };

  const cerrarImagen = () => {
    setIsImageExpanded(false);
  };

  const handleSelect = () => {
    if (onSelect) {
      onSelect(id);
    }
  };

  const handleKeyDown = (e) => {
    if (!onSelect) {
      return;
    }

    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();

      handleSelect();
    }
  };

  useEffect(() => {
    if (!isImageExpanded) {
      return undefined;
    }

    const cerrarConEscape = (e) => {
      if (e.key === "Escape") {
        cerrarImagen();
      }
    };

    document.addEventListener("keydown", cerrarConEscape);

    const scrollAnterior = document.body.style.overflow;

    document.body.style.overflow = "hidden";

    return () => {
      document.removeEventListener("keydown", cerrarConEscape);

      document.body.style.overflow = scrollAnterior;
    };
  }, [isImageExpanded]);

  return (
    <>
      <article
        className={`industrial-product-card ${
          onSelect ? "industrial-product-selectable" : ""
        }`}
        onClick={handleSelect}
        onKeyDown={handleKeyDown}
        role={onSelect ? "button" : undefined}
        tabIndex={onSelect ? 0 : undefined}
      >
        {/* =====================================================
            IMAGEN
        ===================================================== */}
        <div
          className="industrial-product-image-wrapper"
          onClick={(e) => e.stopPropagation()}
        >
          {img ? (
            <img
              src={img}
              alt={title}
              className="industrial-product-image"
              loading="lazy"
              decoding="async"
              fetchPriority="low"
              onClick={abrirImagen}
            />
          ) : (
            <div className="industrial-product-no-image">
              <i className="bi bi-image"></i>

              <span>Sin imagen</span>
            </div>
          )}

          {img && (
            <button
              type="button"
              className="industrial-product-view-button"
              onClick={abrirImagen}
              aria-label={`Ver imagen ampliada de ${title}`}
              title="Ver imagen"
            >
              <i className="bi bi-arrows-fullscreen"></i>
            </button>
          )}

          <span className="industrial-product-badge">Disponible</span>
        </div>

        {/* =====================================================
            INFORMACIÓN
        ===================================================== */}
        <div
          className="industrial-product-body"
          onClick={(e) => e.stopPropagation()}
        >
          <div className="industrial-product-title-wrap">
            <span className="industrial-product-kicker">G&amp;J FRÍO</span>

            <h3 title={title}>{title}</h3>
          </div>

          <div className="industrial-product-actions">
            <button
              type="button"
              className="industrial-product-detail-button"
              data-bs-toggle="modal"
              data-bs-target={`#product-modal-${id}`}
            >
              <i className="bi bi-info-circle-fill"></i>
              Ver detalles
            </button>

            {img && (
              <button
                type="button"
                className="industrial-product-image-button"
                onClick={abrirImagen}
              >
                <i className="bi bi-image"></i>
              </button>
            )}
          </div>
        </div>
      </article>

      {/* =======================================================
          MODAL DETALLE
      ======================================================= */}
      <div
        className="modal fade"
        id={`product-modal-${id}`}
        tabIndex="-1"
        aria-labelledby={`product-modal-label-${id}`}
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered industrial-product-modal">
          <div className="modal-content industrial-product-modal-content">
            <div className="modal-header industrial-product-modal-header">
              <div>
                <span>INFORMACIÓN DEL PRODUCTO</span>

                <h5 className="modal-title" id={`product-modal-label-${id}`}>
                  {title}
                </h5>
              </div>

              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Cerrar"
              ></button>
            </div>

            <div className="modal-body industrial-product-modal-body">
              <div className="industrial-product-modal-layout">
                {/* IMAGEN */}
                <div className="industrial-product-modal-image-area">
                  {img ? (
                    <button
                      type="button"
                      className="industrial-product-modal-image-button"
                      onClick={abrirImagen}
                    >
                      <img src={img} alt={title} />

                      <span>
                        <i className="bi bi-arrows-fullscreen"></i>
                        Ampliar imagen
                      </span>
                    </button>
                  ) : (
                    <div className="industrial-product-modal-no-image">
                      <i className="bi bi-image"></i>

                      <span>Sin imagen disponible</span>
                    </div>
                  )}
                </div>

                {/* DETALLES */}
                <div className="industrial-product-details">
                  {details
                    .filter(
                      (detail) =>
                        detail?.value !== undefined &&
                        detail?.value !== null &&
                        String(detail.value).trim() !== "",
                    )
                    .map((detail) => (
                      <div
                        className={`industrial-product-detail-row ${
                          detail.label?.toLowerCase() === "descripción" ||
                          detail.label?.toLowerCase() === "descripcion"
                            ? "industrial-product-detail-description"
                            : ""
                        }`}
                        key={detail.label}
                      >
                        <span>{detail.label}</span>

                        <strong>{detail.value}</strong>
                      </div>
                    ))}

                  {details.filter(
                    (detail) =>
                      detail?.value !== undefined &&
                      detail?.value !== null &&
                      String(detail.value).trim() !== "",
                  ).length === 0 && (
                    <div className="industrial-product-no-details">
                      <i className="bi bi-info-circle"></i>

                      <span>No hay información adicional disponible.</span>
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="modal-footer industrial-product-modal-footer">
              <button
                type="button"
                className="industrial-product-close-button"
                data-bs-dismiss="modal"
              >
                <i className="bi bi-x-lg"></i>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* =======================================================
          VISOR DE IMAGEN
      ======================================================= */}
      {isImageExpanded && (
        <div
          className="industrial-image-overlay"
          role="dialog"
          aria-modal="true"
          aria-labelledby={`image-viewer-title-${id}`}
          onMouseDown={(e) => {
            if (e.target === e.currentTarget) {
              cerrarImagen();
            }
          }}
        >
          <div className="industrial-image-viewer">
            <div className="industrial-image-viewer-header">
              <div>
                <span>VISTA DEL PRODUCTO</span>

                <h3 id={`image-viewer-title-${id}`}>{title}</h3>
              </div>

              <button
                type="button"
                onClick={cerrarImagen}
                aria-label="Cerrar imagen"
              >
                <i className="bi bi-x-lg"></i>
              </button>
            </div>

            <div className="industrial-image-viewer-body">
              <img src={img} alt={title} />
            </div>

            <div className="industrial-image-viewer-footer">
              <span>
                <i className="bi bi-zoom-in"></i>
                Imagen ampliada
              </span>

              <button type="button" onClick={cerrarImagen}>
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default IndustrialProduct;
